import * as Sentry from '@sentry/browser';
// require('dotenv').config();

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
Sentry.init({ dsn: sentryDsn });

export { Sentry };
